<div class="assessment-details-container">
    <div class="back-btn">
        <span (click)="goToAssessmentListing()" class="clickable">
            <svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.7077 12.0028L4.4045 11.9999M4.4045 11.9999L8.2553 7.96073M4.4045 11.9999L8.2553 16.0391"
                    stroke="#fff" stroke-linecap="round" stroke-linejoin="round" />
            </svg> Back to assessment Listing
        </span>
    </div>
    <div *ngIf="fromAction">
        <div class="assessment-header-card" *ngIf="assessmentDetails && !loadingDetails">
            <!-- Header Row for Labels -->
            <div class="header-labels-row">
                <div class="header-label-item">Version</div>
                <div class="header-label-item">Change Assessment Number</div>
                <div class="header-label-item">Title</div>
                <div class="header-label-item">ECR/ECN Number</div>
                <div class="header-label-item">Type of Change</div>
                <div class="header-label-item">Product Family</div>
                <div class="header-label-item">Created By</div>
                <div class="header-label-item">Start Date</div>
                <div class="header-label-item">End Date</div>
                <div class="header-label-item">Change Assessment Status</div>
                <div class="header-label-item">Impact Yes</div>
                <div class="header-label-item">Impact No</div>
                <div class="header-label-item">Actions</div>
            </div>
    
            <!-- Data Row for Values -->
            <div class="header-values-row">
                <div class="header-value-item">
                    v{{ assessmentDetails.version_number }}
                    <i class="pi pi-info-circle info-icon"></i>
                </div>
                <div class="header-value-item"><span class="truncate-text">{{ assessmentDetails.change_assess_no }}</span></div>
                <div class="header-value-item"><span class="truncate-text">{{ assessmentDetails.title || 'N/A' }}</span></div>
                <div class="header-value-item">{{ assessmentDetails.ecn_ern }}</div>
                <div class="header-value-item">
                    {{ assessmentDetails.change_types[0] | truncate: 15}}
                    <span class="badge-count" *ngIf="assessmentDetails.change_types.length > 1" (click)="toggleOverlay($event, assessmentDetails.change_types, 'Type of Change')">+{{
                        assessmentDetails.change_types.length -1 }}</span>
                </div>
                <div class="header-value-item">
                    {{ assessmentDetails.product_families[0] | truncate: 15 }} 
                    <span class="badge-count" *ngIf="assessmentDetails.product_families.length > 1" (click)="toggleOverlay($event, assessmentDetails.product_families, 'Product Family')">+{{
                        assessmentDetails.product_families.length -1 }}</span>
                </div>
                <div class="header-value-item">{{ assessmentDetails.created_by_name }}</div>
                <div class="header-value-item">{{ formatDate(assessmentDetails.issue_date) }}</div>
                <div class="header-value-item">{{ formatDate(assessmentDetails.due_date) }}</div>
                <div class="header-value-item">
                    <span class="status-badge" [ngStyle]="{
                        'background-color': getStatusStyles(assessmentDetails.status_name).backgroundColor,
                        'color': getStatusStyles(assessmentDetails.status_name).color
                    }">
                        {{ assessmentDetails.status_name }}
                    </span>
                </div>
                <div class="header-value-item">{{ assessmentDetails.impact || 0 }}</div>
                <div class="header-value-item">{{ (assessmentDetails.no_impact || 0)}}</div>
                <div class="header-value-item">
                    <button class="view-button" (click)="onViewAssessmentDetails()">
                        View
                    </button>
                </div>
            </div>
        </div>
    
        <div *ngIf="loadingDetails" class="loading-spinner">
            <p-progressSpinner></p-progressSpinner>
            <p>Loading assessment details...</p>
        </div>
        <div class="assessment-tabs" *ngIf="assessmentDetails && !loadingDetails && shouldShowResponseForms() && currentUserRole !== UserRole.LocalRA && currentUserRole !== UserRole.LocalRA1">
            <button class="tab-button" [class.active]="activeTab === 'Total'" (click)="onTabChange('Total')">
                Total ({{ totalItemsCount }})
            </button>
            <button class="tab-button" [class.active]="activeTab === 'Responded'" (click)="onTabChange('Responded')">
                Responded ({{ respondedItemsCount }})
            </button>
            <button class="tab-button" [class.active]="activeTab === 'Pending'" (click)="onTabChange('Pending')">
                Pending ({{ pendingItemsCount }})
            </button>
        </div>
        <div class="assessment-items-section" *ngIf="assessmentDetails && !loadingDetails">
            <app-table 
                [data]="assessmentItems" [columns]="itemColumns" [rows]="itemPageSize" [showGlobalFilter]="enableGlobalSearch()"
                [totalRecords]="itemTotalRecords" [showPaginator]="true" [selectionMode]="tableSelectionMode"
                (lazyLoadData)="onLazyLoadEventFromItemTable($event)" [showSort]="true" [showFilter]="true"
                [loading]="loadingItems" [globalFilterFields]="itemGlobalFilterFields" [actions]="itemActions"
                [filterConfig]="itemFiltersConfig" [(filterValue)]="itemFiltersValue"
                (searchClicked)="onItemsSearchClicked($event)" (customBtnClicked)="onToggleItemAction($event)"
                [showExportButton]="true" (onExportClick)="handleExport()" (globalSearch)="onItemGlobalSearch($event)" (selectedRowsChange)="onSelectedItemsChange($event)"
                [showConditionalButton]="showBulkActionButton" [conditionalButtonConfig]="bulkActionButtonConfig" (conditionalButtonClick)="handleBulkAction()"
                [customButtonVisibilityFn]="canShowStartAssignButtons.bind(this)" [assessmentDetails]="assessmentDetails">
                <ng-template pTemplate="body" let-col let-rowData="rowData">
                    <ng-container *ngIf="col.field === 'response_status'">
                        <span class="status-badge" [ngClass]="getStatusClass(rowData[col.field])">
                            {{ rowData[col.field] }}
                        </span>
                    </ng-container>
                    <ng-container *ngIf="col.field === 'version'">
                        {{ rowData[col.field] }} <i class="pi pi-info-circle info-icon"></i>
                    </ng-container>
                    <ng-container *ngIf="col.field !== 'response_status' && col.field !== 'version'">
                        {{ rowData[col.field] }}
                    </ng-container>
                </ng-template>
                <ng-template pTemplate="actions" let-rowData="rowData">
                    <div class="action-buttons-group">
    
                    </div>
                </ng-template>
            </app-table>
        </div>
        <div *ngIf="showMailPopupDialog">
            <app-assessment-mail-popup [visible]="showMailPopupDialog" (closeDialog)="onMailPopupClose()" [data]="mailPopupData" (emailSent)="onEmailSent($event)"></app-assessment-mail-popup>
        </div>
        <div *ngIf="displayRcaDetailsPopup">
            <app-manage-assessment-detail-popup [(visible)]="displayRcaDetailsPopup" [mappingId]="mappingIdValue" [historyId]="historyId"
                (closeDialog)="onRcaDetailsDialogClose()"></app-manage-assessment-detail-popup>
        </div>
        <div *ngIf="displayAssessmentDetailsPopup">
            <app-manage-assessment-detail-popup [(visible)]="displayAssessmentDetailsPopup" [mappingId]="assessmentDetailsPopupData" [historyId]="null"
                (closeDialog)="onAssessmentDetailsDialogClose()"></app-manage-assessment-detail-popup>
        </div>
    </div>
    <div *ngIf="fromVersion && !historyId">
        <div class="assessment-header-card" *ngIf="versionDetails.length > 0">
            <!-- Header Row for Labels -->
            <div class="version-header-labels-row">
                <div class="header-label-item">Version</div>
                <div class="header-label-item">Status</div>
                <div class="header-label-item">RA Admin</div>
                <div class="header-label-item">Timestamp</div>
                <div class="header-label-item">Remarks</div>
                <div class="header-label-item">Actions</div>
            </div>
    
            <!-- Data Row for Values -->
            <div class="version-header-values-row" *ngFor="let item of versionDetails">
                <div class="header-value-item">
                    v{{ item.version }}
                </div>
                <div class="header-value-item">{{ item.status }}</div>
                <div class="header-value-item">{{ item.action_by_name | truncate:20 }}</div>
                <div class="header-value-item">{{ formatDate(item.action_at) }}</div>
                <div class="header-value-item" pTooltip="{{ item.remark}}" tooltipStyleClass="custom-tooltip">{{ item.remark | truncate:40 }}</div>
                <div class="header-value-item">
                    <button *ngIf="item.revised_version_id" class="view-button" (click)="onViewVersionHistory(item)">
                        View
                    </button>
                </div>
            </div>
        </div>
    </div>
    <p-overlayPanel #op>
        <ng-template pTemplate="content">
            <div class="version-overlay-content">
                <div class="overlay-panel-header">
                    <span>{{ overlayPanelTitle }}</span>
                    <i class="pi pi-times close-icon" (click)="op.hide()"></i>
                </div>
                <div class="overlayPanelList">
                    <div *ngFor="let item of overlayPanelData" class="version-item">
                        {{ item }}
                    </div>
                </div>
            </div>
        </ng-template>
    </p-overlayPanel>
</div>

<div *ngIf="displayRcaDetailsFormPopup">
    <app-manage-assessment-response-form [isReviseCheck]="isReviseCheck" [(visible)]="displayRcaDetailsFormPopup" [mappingId]="mappingIdValue" [reviseResponse]="isReviseResponse"
        (closeDialog)="onRcaDetailsFormDialogClose($event)" (responseDraft)="handleResponseDraft($event)"></app-manage-assessment-response-form>
</div>

<div *ngIf="displayRcaAssignPopup">
    <app-manage-response-assign-popup [(visible)]="displayRcaAssignPopup" [mappingId]="mappingIdValue"
        (closeDialog)="onRcaAssignDialogClose()" (assessmentAssigned)="assignSuccess($event)"></app-manage-response-assign-popup>
</div>

<app-success
  [(visible)]="showCustomerDetailsSuccessDialog"
  [dialogTitle]="customerDetailsSuccessDialogTitle"
  [successMessage]="customerDetailsSuccessMessage"
  (onClose)="onCustomerDetailsSuccessDialogClose()"
></app-success>

<app-assessment-confirmation-popup [(visible)]="showConfirmationPopup" [config]="confirmationConfig"
    (confirmed)="onConfirmation($event)"></app-assessment-confirmation-popup>
